module.exports = __webpack_public_path__ + "static/img/a204.aff31f07.png";